import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { DownloadPlanPdfResponse, PlanType } from '@efficiently/models';

import { PdfRequestsRepository } from '@efficiently/client-api-plans';

import { DOWNLOAD_PLAN_PDF } from '../queries/download-plan-pdf';
import { planTypeToGraphqlEnumName } from './utils/plan-type-graphql.util';

@Injectable()
export class PdfRequestsGqlRepository extends PdfRequestsRepository {
	private readonly apollo = inject(Apollo);

	public override downloadPlanPdf(
		projectId: string,
		versionId?: string,
		type?: PlanType,
	): Observable<DownloadPlanPdfResponse> {
		return this.apollo
			.mutate({
				mutation: DOWNLOAD_PLAN_PDF,
				variables: {
					projectId,
					versionId,
					type: planTypeToGraphqlEnumName(type),
				},
			})
			.pipe(map(({ data }) => data.downloadPlanPdf));
	}
}
